import { isAdminPath } from '@/admin/paths';

/**
 * Paths that never report a page view. Mirrors the regex in `index.html`,
 * which decides whether the GTM tag loads at all; keep the two in sync.
 */
export function isUntrackedPath(pathname: string): boolean {
  return isAdminPath(pathname) || /^\/front(\/|$)/.test(pathname);
}
